import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]
  
  static values = {
    min: { type: Number, default: 1 },
    max: { type: Number, default: 999999 },
    hasMax: { type: Boolean, default: false }
  }

  get currentValue() {
    return parseInt(this.inputTarget.value, 10) || this.minValue
  }

  set currentValue(val) {
    let clampedValue = Math.max(val, this.minValue)
    if (this.hasMaxValue) {
      clampedValue = Math.min(clampedValue, this.maxValue)
    }
    this.inputTarget.value = clampedValue
    this.displayTarget.textContent = clampedValue
    this.updateButtonStates()
    
    // Dispatch custom event for parent controllers to listen to
    this.element.dispatchEvent(new CustomEvent('quantity-change', {
      bubbles: true,
      detail: { value: clampedValue }
    }))
  }

  connect() {
    this.updateButtonStates()
  }

  increase(event) {
    event.preventDefault()
    if (!this.hasMaxValue || this.currentValue < this.maxValue) {
      this.currentValue = this.currentValue + 1
    }
  }

  decrease(event) {
    event.preventDefault()
    if (this.currentValue > this.minValue) {
      this.currentValue = this.currentValue - 1
    }
  }

  updateButtonStates() {
    const decreaseBtn = this.element.querySelector('.quantity-btn-decrease')
    const increaseBtn = this.element.querySelector('.quantity-btn-increase')
    
    if (decreaseBtn) {
      decreaseBtn.disabled = this.currentValue <= this.minValue
    }
    if (increaseBtn) {
      increaseBtn.disabled = this.hasMaxValue && this.currentValue >= this.maxValue
    }
  }
}
